import type { MBasketBuy } from "@/Models/MBasketBuy/MBasketBuy";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";
import type { products } from "@/Models/MProduct/Products";

export const mapperToCheckoutBuy = (
  //p: products[],
  p: products,
  quantity: number,
  basketBuySku: MBasketBuy[],
  ipx: string
) => {
  if (basketBuySku && basketBuySku.length > 0) {
    //datos del producto.
    const Price = p.Price ?? {};

    //total de productos.
    const totalX = Number(Price) * quantity;

    //obtenemos los datos de la compra.
    const basketIdBuy = basketBuySku[0]?.basketId ?? "";

    const customerIdBuy = basketBuySku[0]?.customerInfo?.customerId ?? "";

    const dataCheckout = (p: products): MCheckout => {
      return {
        skuId: p.Id,
        productsItem: p,
        quant: quantity,
        ipAddress: ipx,
        basketId: String(basketIdBuy),
        totalSalesPrice: totalX,
        customerId: String(customerIdBuy),
      };
    };

    const arrayProduct = [p]

    const resultData = arrayProduct.map(dataCheckout);

    return resultData;
  }
  return [];
};
